import { render, staticRenderFns } from "./component-video.vue?vue&type=template&id=7b591b1c&scoped=true&"
import script from "./component-video.vue?vue&type=script&lang=js&"
export * from "./component-video.vue?vue&type=script&lang=js&"
import style0 from "./component-video.vue?vue&type=style&index=0&id=7b591b1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b591b1c",
  null
  
)

export default component.exports